import React, {Component} from 'react'
import {SliderTemplateStyle} from './../../../../../styles'
import defaultPicture from './../../../../../static/default_picture_RM.jpg'
import { getAverageColor } from './../../../../../helpers/getAverageColor'

export default class SliderTemplate extends Component {
  state = {
    active: 0,
    lastPicture: defaultPicture,
    ready: true,
    color: false, 
  }

  componentDidMount() {
      this.setState({
        lastPicture: this.props.fields.items.length > 0 && this.props.fields.items[0].image !== '' ? this.props.fields.items[0].image : this.state.lastPicture,
        lastPicturePosition: this.props.fields.items.length > 0 && this.props.fields.items[0].picture_position !== '' ? this.props.fields.items[0].picture_position : this.state.lastPicturePosition
      }, () => {
        this.updateAverageColor()
      })
  }

  updateSlides = (index) => (e) => {
    e.preventDefault()
    this.setState({ ready: false })
    this.timer = setTimeout(() => {
      this.setState({ 
        active: index,
        lastPicture: this.props.fields.items[index].image !== '' ? this.props.fields.items[index].image : this.state.lastPicture,
        lastPicturePosition: this.props.fields.items[index].picture_position !== '' ? this.props.fields.items[index].picture_position : this.state.lastPicturePosition,
      }, () => {
        this.updateAverageColor()
      })
    }, 500)
  }

  updateAverageColor = () => {
    getAverageColor(this.state.lastPicture).then((data) => {
      this.setState({
        color: data,
        ready: true,
      })
    }).catch((e) => {
      console.log(e)
    })
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
  }
  
  render() {
    const { title, fields, isBrand, subtitle, category } = this.props
    const { ready, lastPicture, lastPicturePosition, active, color } = this.state
    // picturePosition should be either : top; center; bottom. default on center.
    const formatedPicturePosition = lastPicturePosition || 'center'
    
    return (
      <div className={`product-template--slider ${SliderTemplateStyle(lastPicture, ready, color)}`}>
         <div className="template-scroll flex">
          <div className={`template-left template-picture template-picture--${formatedPicturePosition}`}></div>
          <div className="template-right template-content">
              { category && isBrand && (<span className="title-brand">{category}</span>) }
              { title && !isBrand  && (<h2 className='subtitle'>{ title }</h2> )}
              { isBrand && subtitle  && (<h2 className={`subtitle subtitle--brand `}>{ subtitle }</h2> )}
              { title && isBrand &&  (<h3 className="subtitle-h3"> {title} </h3>)}
            <ul className="reset">
              {
                fields.items.map((slide, index) => (
                  <li key={index} className={`flex ${ index === active ? 'active' : ''}`} onClick={this.updateSlides(index)}> 
                    <span className="number">{index + 1}</span> 
                    <span className="label"> { slide.description } </span>
                  </li>
                ))
              }
            </ul>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Product/ProductTemplates/SliderTemplate.js